var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.isShow)?_c('div',{staticClass:"page",on:{"click":_vm.handleClose}},[_c('img',{staticClass:"share",attrs:{"src":_vm.shareArrow}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }